<div class="section over-hide padding-top-120 padding-top-mob-nav section-background-rana-3 background-img-top">
    <div class="section-1400 padding-top-bottom-120">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-7 col-xl-5">
                    <small *ngIf="chapterCreationError" class="font-weight-500 text-danger">Failed to create chapter.
                        Please try
                        again.</small>

                    <div
                            class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-white section-background-24 background-img-top form">
                        <form [formGroup]="chapterForm" class="section nfr-form-standard">
                            <h4 class="mb-4 text-sm-center">Create a New Chapter</h4>

                            <div class="form-group">
                                <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="text-danger">
                                    <small *ngIf="name?.errors?.['required']" class="font-weight-500">Chapter Name is
                                        required.</small>
                                </div>
                                <input type="text" formControlName="name"
                                       class="form-style big gray-version no-shadow form-style-with-icon section-shadow-blue"
                                       placeholder="Chapter Name" autocomplete="off"/>
                                <i class="input-icon big uil uil-building"></i>
                            </div>

                            <div class="form-group mt-3">
                                <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="text-danger">
                                    <small *ngIf="location?.errors?.['required']" class="font-weight-500">Chapter
                                        Location is
                                        required.</small>
                                </div>
                                <input type="text" formControlName="location"
                                       class="form-style big gray-version no-shadow form-style-with-icon section-shadow-blue"
                                       placeholder="Chapter Location" autocomplete="off"/>
                                <i class="input-icon big uil uil-map-marker"></i>
                            </div>

                            <div class="form-group mt-3">
                                <input type="text" formControlName="logouri"
                                       class="form-style big gray-version no-shadow form-style-with-icon section-shadow-blue"
                                       placeholder="Logo URI" autocomplete="off"/>
                                <i class="input-icon big uil uil-image"></i>
                            </div>

                            <div class="form-group mt-3">
                <textarea formControlName="welcomeNote"
                          class="form-style big gray-version no-shadow section-shadow-blue" placeholder="Welcome Note"
                          rows="3"></textarea>
                                <i class="input-icon big uil uil-comment-alt"></i>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12 text-sm-center">
                                    <button type="button" (click)="createChapter()" class="btn btn-dark-primary">
                                        Create Chapter<i class="uil uil-plus-circle size-22 ml-3"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
